module.exports = __webpack_public_path__ + "static/media/img-googleplay.ba2e5087.png";